import api from '@shared/services/api';

export const locations = {
    getLocations: async (searchParams = {}) => {
        try {
            const params = {};
            
            // Add search parameters if they exist
            if (searchParams.name) {
                params.name = searchParams.name.trim();
            }
            if (searchParams.description) {
                params.description = searchParams.description.trim();
            }
            if (searchParams.cityName) {
                params.cityName = searchParams.cityName.trim();
            }
            if (searchParams.active !== undefined && searchParams.active !== null) {
                params.active = searchParams.active;
            }

            const response = await api.get('/location', { params });
            return response.data;
        } catch (error) {
            console.error('❌ [locationsService] Error getting locations:', error);
            throw error;
        }
    },
    searchCities: async (name) => {
        try {
            const response = await api.get('/cities/list', { 
                params: { name: name.trim() } 
            });
            return response.data;
        } catch (error) {
            console.error('Error searching cities:', error);
            throw error;
        }
    },
    createLocation: async (locationData) => {
        try {
            const response = await api.post('/location', locationData);
            return response.data;
        } catch (error) {
            console.error('Error creating location:', error);
            throw error;
        }
    },
    updateLocation: async (id, locationData) => {
        try {
            const response = await api.put(`/location/${id}`, locationData);
            return response.data;
        } catch (error) {
            console.error('Error updating location:', error);
            throw error;
        }
    },
    deleteLocation: async (id) => {
        try {
            const response = await api.delete(`/location/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting location:', error);
            throw error;
        }
    },
    getTranslation: async (locationId) => {
        try {
            const response = await api.get(`/location/translation/${locationId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting location translation:', error);
            throw error;
        }
    },
    saveTranslation: async (translationData) => {
        try {
            const response = await api.post('/location/translate', translationData);
            return response.data;
        } catch (error) {
            console.error('Error saving location translation:', error);
            throw error;
        }
    },
  
   
    // Report data method for frontend PDF/Excel generation
    getLocationsReportData: async (searchParams = {}) => {
        try {
            const params = {};
            
            if (searchParams.name) {
                params.name = searchParams.name.trim();
            }
            if (searchParams.description) {
                params.description = searchParams.description.trim();
            }
            if (searchParams.cityName) {
                params.cityName = searchParams.cityName.trim();
            }
            if (searchParams.active !== undefined && searchParams.active !== null) {
                params.active = searchParams.active;
            }

            const response = await api.get('/location', { params });
            return response.data.content || [];
        } catch (error) {
            console.error('Error fetching locations report data:', error);
            throw error;
        }
    }

}